<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc"><h1>Contents</h1><ol><li id="level1-titlepage"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></li>
<li id="level1-toc"><a href="#/toc">Contents</a></li>
<li id="level1-front3"><a href="#/front01">Copyright</a></li>
<li id="level1-front4"><a href="#/front02">Dedication</a></li>
<li id="level1-front5"><a href="#/front03">Introduction</a></li>
<li id="c01"><a href="#/c01">Lily Daw and the Three Ladies</a>
</li>
<li id="c02"><span href="#/c02" title="Link target outside of Sample">A Piece of News</span>
</li>
<li id="c03"><span href="#/c03" title="Link target outside of Sample">Petrified Man</span>
</li>
<li id="c04"><span href="#/c04" title="Link target outside of Sample">The Key</span>
</li>
<li id="c05"><span href="#/c05" title="Link target outside of Sample">Keela, the Outcast Indian Maiden</span>
</li>
<li id="c06"><span href="#/c06" title="Link target outside of Sample">Why I Live at the P.O.</span>
</li>
<li id="c07"><span href="#/c07" title="Link target outside of Sample">The Whistle</span>
</li>
<li id="c08"><span href="#/c08" title="Link target outside of Sample">The Hitch-Hikers</span>
</li>
<li id="c09"><span href="#/c09" title="Link target outside of Sample">A Memory</span>
</li>
<li id="c10"><span href="#/c10" title="Link target outside of Sample">Clytie</span>
</li>
<li id="c11"><span href="#/c11" title="Link target outside of Sample">Old Mr. Marblehall</span>
</li>
<li id="c12"><span href="#/c12" title="Link target outside of Sample">Flowers for Marjorie</span>
</li>
<li id="c13"><span href="#/c13" title="Link target outside of Sample">A Curtain of Green</span>
</li>
<li id="c14"><span href="#/c14" title="Link target outside of Sample">A Visit of Charity</span>
</li>
<li id="c15"><span href="#/c15" title="Link target outside of Sample">Death of a Traveling Salesman</span>
</li>
<li id="c16"><span href="#/c16" title="Link target outside of Sample">Powerhouse</span>
</li>
<li id="c17"><span href="#/c17" title="Link target outside of Sample">A Worn Path</span>
</li>
<li id="level1-back40"><span href="#/back01" title="Link target outside of Sample">Read More from Eudora Welty</span></li>
<li id="level1-back41"><span href="#/back02" title="Link target outside of Sample">About the Author</span></li>
<li id="level1-back42"><span href="#/back03" title="Link target outside of Sample">Connect with HMH</span></li></ol></nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?3abed3f6